(() => {
  function init(root = document) {
    root.querySelectorAll('video.sd-story-video').forEach(video => {
      if (video.dataset.autoplayReady) return;
      video.dataset.autoplayReady = 'true';
      video.controls = false;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = false;
      video.preload = 'none';
      video.removeAttribute('autoplay');
      video.removeAttribute('controls');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      const fallback = document.createElement('button');
      fallback.type = 'button';
      fallback.className = 'sd-video-play';
      fallback.textContent = 'Video afspelen';
      fallback.hidden = true;
      video.after(fallback);
      let visible = false;
      const image = document.querySelector('.sd-media-panel.is-active img');
      let imageReady = !image || image.complete;
      const play = () => {
        const promise = video.play();
        if (promise) promise.then(() => { fallback.hidden = true; })
          .catch(() => { fallback.hidden = !visible; });
      };
      const update = () => {
        if (visible && imageReady && !document.hidden) play();
        else video.pause();
      };
      fallback.addEventListener('click', play);
      video.addEventListener('playing', () => { fallback.hidden = true; });
      if (!imageReady) {
        const ready = () => { imageReady = true; update(); };
        image.addEventListener('load', ready, { once: true });
        image.addEventListener('error', ready, { once: true });
      }
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          update();
        }, { threshold: 0.1 });
        observer.observe(video);
        document.addEventListener('visibilitychange', update);
      } else {
        fallback.hidden = false;
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
